import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=16367a12&"
import script from "./NotificationCard.vue?vue&type=script&lang=js&"
export * from "./NotificationCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=16367a12&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16367a12')) {
      api.createRecord('16367a12', component.options)
    } else {
      api.reload('16367a12', component.options)
    }
    module.hot.accept("./NotificationCard.vue?vue&type=template&id=16367a12&", function () {
      api.rerender('16367a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications/NotificationCard.vue"
export default component.exports